var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('service',{attrs:{"ws":_vm.ws,"data":_vm.data,"spinner":_vm.ws_spinner},on:{"success":_vm.onSuccess,"error":function($event){return _vm.console.log($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }